var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tagList),function(sea){return _c('el-tag',{key:sea.key + sea.title,attrs:{"type":sea.key=='TypeView'?'danger':''}},[_vm._v(_vm._s(sea.title+':'+sea.value))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }